/*
 * Shared style constants for the generic DataTable. Centralized so the real
 * <thead>, the floating clone <thead> and the actions column always match.
 * Header look mirrors the Progression table for visual parity across features.
 */

export const DATA_TABLE_HEAD_CLASS = 'tw:bg-gray-50 '
  + 'tw:[&_th]:font-semibold! tw:[&_th]:text-xs! tw:[&_th]:text-gray-500! tw:[&_th]:align-middle!'

export const DATA_TABLE_TABLE_CLASS = 'tw:[border-collapse:separate] tw:[border-spacing:0] '
  + 'tw:mb-0! tw:border-0! '
  + 'tw:[&_th:not(:last-child)]:p-4! tw:[&_td:not(:last-child)]:p-4! '
  + 'tw:[&_td]:align-middle!'

// Rightmost column shared between the actions <th> and the actions <td>.
export const DATA_TABLE_ACTIONS_COL_CLASS = 'tw:min-w-12 tw:px-1! tw:py-1.5!'

export const DATA_TABLE_ACTIONS_STICKY_CLASS = 'tw:sticky tw:right-0 tw:z-10'
